module.exports = __webpack_public_path__ + "static/media/VectorPointInacabado15.4355d990.svg";